import React from 'react';
import {Toast, ToastSkin} from 'wix-ui-tpa';
import {useControllerProps} from '../../../domain/controllers/ControllerContext';
import {classes} from './ErrorToast.st.css';
import {useTranslation} from '@wix/yoshi-flow-editor';

export enum ErrorToastDataHook {
  root = 'ErrorToast.root',
}

export const ErrorToast = () => {
  const {shouldShowError, clearError} = useControllerProps().cartStore;
  const {t} = useTranslation();

  return shouldShowError ? (
    <Toast
      data-hook={ErrorToastDataHook.root}
      skin={ToastSkin.error}
      onClose={() => clearError()}
      className={classes.errorToast}
      shouldShowCloseButton>
      {t('sideCart.generalError.toast')}
    </Toast>
  ) : null;
};
